export default "__VITE_ASSET__3urTJ5X9__"